webpackJsonp([79],{

/***/ 1325:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1326);


/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(170);

var _datetime2 = _interopRequireDefault(_datetime);

var _enGb = __webpack_require__(771);

var _enGb2 = _interopRequireDefault(_enGb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en-gb', _enGb2.default);

/***/ })

},[1325]);


// WEBPACK FOOTER //
// app/datetime.en-gb-55958f0f25c71e9b3a42.js